import { render } from "./UserEntityLink.vue?vue&type=template&id=e167e408&scoped=true"
import script from "./UserEntityLink.vue?vue&type=script&lang=js"
export * from "./UserEntityLink.vue?vue&type=script&lang=js"

import "./UserEntityLink.vue?vue&type=style&index=0&id=e167e408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e167e408"]])

export default __exports__